export const SELECTOR = 'featured-series';

export const VIZ_SELECTOR = 'featured-series-viz';
